// Checkout-side rules for the seller-configurable Name / Full Address length
// limit (FW-2895). The config lives on the requestedFields entry as
// `characterLimit: { active, min, max }`.
//
// Same rules as helpers/buyerFieldCharacterLimit.js (server + seller editor)
// and components-checkout/src/shared/buyerFieldCharacterLimit.js (Classic
// theme). Keep all three in sync; server/tests/unit/helpers/buyerFieldCharacterLimit.test.js
// runs the same cases against each copy.

// Allowed range per field. The upper bound is also the default maximum.
export const CHARACTER_LIMIT_RANGES = {
  name: { min: 3, max: 60 },
  addressText: { min: 3, max: 200 }
}

function isValidLimitNumber (value, range) {
  return Number.isInteger(value) && value >= range.min && value <= range.max
}

// The limit to enforce for a requestedFields entry, or null. Missing, partial
// or out-of-range config counts as switched off; hidden fields are skipped.
export function getActiveCharacterLimit (requestedField) {
  if (!requestedField || !requestedField.active) return null
  const range = CHARACTER_LIMIT_RANGES[requestedField.field]
  const limit = requestedField.characterLimit
  if (!range || !limit || limit.active !== true) return null
  if (!isValidLimitNumber(limit.min, range) || !isValidLimitNumber(limit.max, range) || limit.min > limit.max) return null
  return { min: limit.min, max: limit.max }
}

// Leading/trailing whitespace is not counted, inner spaces are. Counts code
// points so an emoji is one character.
export function countCharacters (value) {
  if (value === undefined || value === null) return 0
  return Array.from(String(value).trim()).length
}

// Returns null when the value is fine, or { type: 'min' | 'max', limit }.
// An empty value is left to the existing required check.
export function getCharacterLimitError (requestedField, value) {
  const limit = getActiveCharacterLimit(requestedField)
  if (!limit) return null

  const length = countCharacters(value)
  if (length === 0) return null
  if (length < limit.min) return { type: 'min', limit: limit.min }
  if (length > limit.max) return { type: 'max', limit: limit.max }
  return null
}
